"use client"; 

import { useState } from 'react';
import Link from 'next/link';
import logger from '../../../lib/logger'
import { classNames } from '../../../lib/helpers'
import {  CheckIcon, XMarkIcon, ArrowTopRightOnSquareIcon,  ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import AppLogo from '../apps/logo';

import ComparisonBlockTitle from './common/comparisonBlockTitle';
import ComparisonPrimaryButton from './common/comparisonPrimaryButton';
import ComparisonTableHeader from './common/comparisonTableHeader';
import ComparisonTableName from './common/comparisonTableName';
import { appIsSourceAutomation } from '../../../lib/helpers';

const COMPARISON_CONNECTIONS_LIST_INITIAL = 10  // Max connections to show initially per app in the comparison integrations block


export default function ComparisonSourceIntegrations({ apps=[], sourcesIntegrations=[] }) {
  logger.info("Component.ComparisonSourceIntegrations rendering.");
  
  const [appAInitial, appBInitial] = apps
  const [sources=[], sourceApps=[], sourceAppsUniqA=[], sourceAppsUniqB=[]] = sourcesIntegrations
  const [sourceA, sourceB] = sources
  const [appA, appB] = [{...appAInitial, source: sourceA}, {...appBInitial, source: sourceB}]

  if (!(sourceApps?.length>0)) return <></>  // If no sourceApps returned 
  
  // Load more 
  const [sourcesAppsExpanded, setSourcesAppsExpanded] = useState(false)
  const itemsList = sourcesAppsExpanded ? sourceApps :  sourceApps?.slice(0, COMPARISON_CONNECTIONS_LIST_INITIAL) 
  const showExpandButton = sourceApps?.length > COMPARISON_CONNECTIONS_LIST_INITIAL

  // Section Title
  const getSectionTitle = () => {    
    const title = ''
    return title    
  }
  const sectionTitle = getSectionTitle()

  // Check if app integrates with item app
  const isSupported = (app, appIndex) => {
    const sourceApp = sourceApps?.find(x => x?.id === app?.id)

    if (appIndex === 0) return sourceApp?.supported_a
    return sourceApp?.supported_b
  }

  const appIdxMaxConnections = sourceA?.count_apps === sourceB?.count_apps ? null : 
  sourceA?.count_apps > sourceB?.count_apps ? 0 : 1

  
  return (
    <>
      <div className="my-12">
        <ComparisonBlockTitle name='Integrations' title={sectionTitle} href='integrations' iconName="CogIcon" />        

        <div className="mt-2 mb-6 grid grid-cols-2 gap-x-4 md:gap-x-12 ">

          {[appA, appB]?.map((app, idx) => (
            <div key={idx} className="">

              <ComparisonTableName 
                keyValue={`title-${idx}`} 
                title={`What apps are supported by ${app?.name}?`}
              />

              <ComparisonTableHeader 
                keyValue={`title-${idx}`} 
                app={app} 
                primary={idx === appIdxMaxConnections} 
                title="Total integrations"
                count={app?.source?.count_apps}
              />

              {itemsList?.map((app, index) => (
                <div key={index} className="flex gap-x-1.5 sm:gap-x-3 ">
                  <div className="flex-shrink-0" >
                    <AppLogo app={app} 
                      className={classNames(isSupported(app, idx) ? '' : 
                        'grayscale', 
                        'w-5 h-5 sm:w-6 sm:h-6 rounded-sm ')} 
                    />
                  </div>
                  
                  <div className="w-full h-full truncate">
                    <p className={classNames(isSupported(app, idx) ? 'text-gray-900' : 'text-gray-300', 'text-sm sm:text-base ')}>
                      {app?.name}                      
                    </p>
                  </div>

                  <div className="flex-shrink-0" >
                    <span className="inline-flex items-center justify-center   ">
                      <span className="text-base font-medium leading-none ">
                        {isSupported(app, idx) ? (
                          <CheckIcon className="h-6 w-6 text-green-500" />
                        ) : (
                          <XMarkIcon className="h-6 w-6 text-red-300" />
                        )}
                      </span>
                    </span>
                  </div>

                </div>
              ))}

              <div key={`expand-button-${idx}`} className="my-3 flex">
                {showExpandButton && (
                  <button
                    type="button"
                    className="mx-auto inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-crisp-700 hover:bg-crisp-100 focus:outline-none"
                    onClick={() => setSourcesAppsExpanded(!sourcesAppsExpanded)}
                  >
                    {sourcesAppsExpanded ? 'Collapse list' : 'Expand' }
                    {sourcesAppsExpanded ? (
                      <ChevronUpIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
                    ) : (
                      <ChevronDownIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
                    )}
                    
                  </button>
                )}
              </div>                 

              <div key={`button-${idx}`} className="my-3">
                <ComparisonPrimaryButton name={`Full list of ${apps[idx]?.name} integrations`} href={`/${apps[idx]?.slug}/integrations`} />
              </div>

            </div>
          ))}
        </div>

      </div> 
    </>
  )
}
